import { FEATURE_FLAGS } from '@/utils/constants/featureFlags';
import { useFeatureFlagEnabled } from 'posthog-js/react';

export const useDiwaliLogo = (): boolean => {
  const showDiwaliLogoEnabled = useFeatureFlagEnabled(FEATURE_FLAGS.SHOW_DIWALI_LOGO);

  return Boolean(showDiwaliLogoEnabled);
};

export default useDiwaliLogo;
